export function decodeJWT (token) {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    } catch (e) {
        console.log(e);
    }
}

// Status is of type enum in DB: ['STARTED', 'STAGING', 'ENDED', 'PLANNED']
export async function updateRoomStatus(status, live_room_id) {
    const res = await axios.patch(`/api/v3/live-rooms/${live_room_id}`, {'status': status});
    return res.data.room.status;
}

export async function updateParticipant(participant_id,  body) {
    await axios.patch(`/api/v3/live-room-participants/${participant_id}`, {
        ...body
    });
}

export async function getParticipantToken(token, participant_id) {
    if (token) {
        const { exp } = decodeJWT(token);
        const isExpired = Date.now() >= exp * 1000; // This should be expanded to also check if the token will expire during the session

        if (!isExpired) return token;
    }

    const response = await axios.patch(`/api/v3/live-room-participants/${participant_id}`);
    return response.data.data.access_token;
}
